import { PlanFeatureProvider } from '~/contexts/PlanFeatureContext';
function AIChatbotChatLayout({ children }) {
    return (
        <PlanFeatureProvider>
            <main className='main'>
                {children}
            </main>
        </PlanFeatureProvider>
    )
}
export default AIChatbotChatLayout;